import React from "react";
import {
  FB_IMG1,
  TWITTER1_IMG,
  YOUTUBE1_IMG,
} from "../../utils/app-image-contant";
import { Link } from "react-router-dom";
const SocialPage = () => {
  const handleOpen = (data) => {
    if (data == "facebook") window.open("https://www.facebook.com/pmbjppmbi/");
    if (data == "youtube")
      window.open("https://www.youtube.com/channel/UCyC_ZjR9g6or1e3TIFr0sPA/");
    if (data == "twitter") window.open("https://twitter.com/pmbjppmbi");
  };

  return (
    <>
      <section className="jana_social_icons">
        <div className="jana_social_icons_inner_sec text-white">
          <ul className="list-unstyled">
            <li className="socialfb-bg ps-2 mb-2 py-1">
              <a className="social-icon-data text-decoration-none text-white py-1 px-2 bhashini-skip-translation">
                FACEBOOK
              </a>
              <Link onClick={() => handleOpen("facebook")} >
                <img
                  src={FB_IMG1}
                  alt=""
                  srcset=""
                  className="socialimg text-white"
                />
              </Link>
            </li>
            <li className="socialyt-bg ps-2 mb-2 py-1">
              <a className="social-icon-data text-decoration-none text-white py-1 px-2 bhashini-skip-translation">
                YOUTUBE{" "}
              </a>
              <Link onClick={() => handleOpen("youtube")} >
                <img
                  src={YOUTUBE1_IMG}
                  alt=""
                  srcset=""
                  className="socialimg text-white"
                />
              </Link>
            </li>
            <li className="socialtw-bg ps-2 py-1">
              <a className="social-icon-data text-decoration-none text-white py-1 px-2 bhashini-skip-translation">
                TWITTER{" "}
              </a>
              <Link onClick={() => handleOpen("twitter")} >
                <img
                  src={TWITTER1_IMG}
                  alt=""
                  srcset=""
                  className="socialtwimg text-white"
                />
              </Link>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default SocialPage;
